import type { Pillar } from '../fr/pillars';

export const PILLARS: readonly Pillar[] = [
  {
    id: 'optimiser',
    icon: 'Workflow',
    title: 'Streamline processes',
    body: 'I analyze operations, find where the time is lost, and put lasting fixes in place.',
    accentClass: 'p',
  },
  {
    id: 'numeriser',
    icon: 'Wrench',
    title: 'Digitize with judgment',
    body: 'I build the tools myself when what the market offers does not fit the shop floor.',
    accentClass: 'm',
  },
  {
    id: 'qualite',
    icon: 'ShieldCheck',
    title: 'Strengthen quality',
    body: 'I design systems that improve traceability, cut down errors and make audits straightforward.',
    accentClass: 'a',
  },
];
